import { render, staticRenderFns } from "./right-swiper.vue?vue&type=template&id=d2f2e88a&scoped=true"
import script from "./right-swiper.vue?vue&type=script&lang=js"
export * from "./right-swiper.vue?vue&type=script&lang=js"
import style0 from "./right-swiper.vue?vue&type=style&index=0&id=d2f2e88a&prod&lang=less"
import style1 from "./right-swiper.vue?vue&type=style&index=1&id=d2f2e88a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f2e88a",
  null
  
)

export default component.exports